import React, { lazy } from "react";

const LazyHome = lazy(() => import("./Error404"));

const Home = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyHome {...props} />;

export default Home;
